import { render, staticRenderFns } from "./ArrangeSections.vue?vue&type=template&id=cb446e84&scoped=true&"
import script from "./ArrangeSections.vue?vue&type=script&lang=js&"
export * from "./ArrangeSections.vue?vue&type=script&lang=js&"
import style0 from "./ArrangeSections.vue?vue&type=style&index=0&id=cb446e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb446e84",
  null
  
)

export default component.exports